// extracted by mini-css-extract-plugin
module.exports = {"top-logo":"index_top-logo_1wq3J","topbarDark":"index_topbarDark_E25oL","logo":"index_logo_8-4lE","logoName":"index_logoName_29EF2","logoDescr":"index_logoDescr_5ux3B"};